module.exports = __webpack_public_path__ + "static/media/System_Integration.30ec602e.svg";